import classNames from 'classnames';

import { Chip } from '../../Chip';

import styles from './InclusiveSelectionGroup.module.scss';
import { InclusiveSelectionGroupProps } from './InclusiveSelectionGroup.types';

/**
 * @deprecated use `InclusiveChipGroup` instead
 * @example import { InclusiveChipGroup, ChipGroupItem } from '@randstad-lean-mobile-factory/react-components-core';
 *
 *          <InclusiveChipGroup value={value} onValueChange={setValue}>
 *            <ChipGroupItem value="0" disabled>item</ChipGroupItem>
 *            <ChipGroupItem value="1">item</ChipGroupItem>
 *          </InclusiveChipGroup>
 */
export const InclusiveSelectionGroup = <T,>({
  values,
  selected,
  buttonClassname,
  setSelected,
  getKey,
  getStringValue,
}: InclusiveSelectionGroupProps<T>) => {
  return (
    <div className={styles.container}>
      {values.map(value => {
        const id = getKey(value);
        const label = getStringValue(value);

        return (
          <Chip
            size="large"
            key={id}
            onClick={() => {
              const filteredSelected = selected.filter(el => getKey(el) !== id);

              if (filteredSelected.length === selected.length) {
                setSelected([...filteredSelected, value]);
              } else {
                setSelected(filteredSelected);
              }
            }}
            selected={selected.includes(value)}
            className={classNames(styles.button, buttonClassname)}
            rounded={false}
          >
            {label}
          </Chip>
        );
      })}
    </div>
  );
};
